import { render } from "./slider.vue?vue&type=template&id=3798cb28&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=3798cb28&scoped=true&lang=css"

import exportComponent from "/var/deploy/staging2/web_head/releases/20251208225915/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3798cb28"]])

export default __exports__